import loadScript from 'utils/load-script';

export type Config = {
  type: 'vimeo' | 'youtube'
  videoId: string
  container: HTMLElement
};

class Video {
  private player:any;

  public readonly config:Config;

  constructor(config:Config) {
    this.player = null;
    this.config = { ...config };
  }

  async loadScript() {
    await loadScript(this.config.type === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js');
  }

  setupPlayer() {
    if (this.config.type === 'youtube') {
      if (window.YT) {
        const aspectContainer = document.createElement('div');
        aspectContainer.classList.add('aspect-ratio', 'aspect-ratio--16/9');
        const youtubeVideoElement = document.createElement('div');
        const { YT } = window;
        YT.ready(() => {
          const options = {
            showinfo: 0,
            controls: 1,
            rel: 0,
            iv_load_policy: 3,
            loop: 0,
            mute: 0,
            playlist: this.config.videoId,
            playsinline: 0,
            modestbranding: 1,
            disablekb: 0,
          };

          this.player = new YT.Player(youtubeVideoElement, {
            videoId: this.config.videoId,
            playerVars: options,
          });
        });
        aspectContainer.append(youtubeVideoElement);
        this.config.container.append(aspectContainer);
      }
    } else if (this.config.type === 'vimeo') {
      if (window.Vimeo) {
        const { Vimeo } = window;
        this.player = new Vimeo.Player(this.config.container, {
          id: +this.config.videoId,
          autoplay: false,
          autopause: false,
          muted: false,
          background: false,
          loop: false,
          responsive: true,
        });
      }
    }
  }

  init() {
    this.loadScript().then(() => {
      this.setupPlayer();
    });
  }
}

export default (config:Config) => new Video(config);
